import { render, staticRenderFns } from "./GoogleTranslateBtn.vue?vue&type=template&id=4d491e88&"
import script from "./GoogleTranslateBtn.vue?vue&type=script&lang=js&"
export * from "./GoogleTranslateBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports